import Vue from 'vue';
import VueRouter from 'vue-router';
import start from '../views/start.vue';
import login from '../views/login.vue';
import home from '../views/home.vue';
import account from '../views/account.vue';
import fundManagement from '../views/fundManagement.vue';
import capitalChangeDetail from '../views/capitalChangeDetail.vue';
import settings from '../views/settings.vue';
import changePassword from '../views/changePassword.vue';
import changePhone from '../views/changePhone.vue';
import changeName from '../views/changeName.vue';
import monthlyReport from '../views/monthlyReport.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/start'
  },
  {
    path: '/start',
    name: 'start',
    component: start,
    meta: { title: '启动页' }
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: { title: '登录' }
  },
  {
    path: '/home',
    name: 'home',
    component: home,
    meta: { title: '首页' }
  },
  {
    path: '/account',
    name: 'account',
    component: account,
    meta: { title: '账户' }
  },
  {
    path: '/fund-management',
    name: 'fundManagement',
    component: fundManagement,
    meta: { title: '资金管理' }
  },
  {
    path: '/capital-change-detail',
    name: 'capitalChangeDetail',
    component: capitalChangeDetail,
    meta: { title: '资金变动明细' }
  },
  {
    path: '/settings',
    name: 'settings',
    component: settings,
    meta: { title: '设置' }
  },
  {
    path: '/change-password',
    name: 'changePassword',
    component: changePassword,
    meta: { title: '修改密码' }
  },
  {
    path: '/change-phone',
    name: 'changePhone',
    component: changePhone,
    meta: { title: '修改手机号' }
  },
  {
    path: '/change-name',
    name: 'changeName',
    component: changeName,
    meta: { title: '修改姓名' }
  },
  {
    path: '/report',
    name: 'monthlyReport',
    component: monthlyReport,
    meta: { title: '每月月报' }
  }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

// 路由守卫：设置页面标题和登录验证
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 不需要登录验证的页面
  const publicPages = ['/start', '/login'];
  const authRequired = !publicPages.includes(to.path);
  const token = localStorage.getItem('token');

  // 如果需要登录但未登录，跳转到登录页
  if (authRequired && !token) {
    return next('/login');
  }

  next();
});

export default router;
